import React from 'react';
import '../../styles/user/ResponsibleGaming.css';

const ResponsibleGaming = () => {
    return (
        <div className="responsible-gaming-page">
            <div className="responsible-gaming-container">

                <h1>Responsible Gaming and Player Protection Information Policy</h1>

                <p>
                    Website is committed to endorsing responsible wagering as well as promoting
                    the awareness of problem gambling and improving prevention, intervention and
                    treatment. Responsible Gambling Policy sets out its commitment to minimising
                    the negative effects of problem gambling and to promoting responsible gambling
                    practices. We consider it as our responsibility to you, our customers, to ensure
                    that you will keep on enjoying your wagering experience on our site, remaining
                    at the same time fully aware of the social and financial harms associated with
                    problematic gambling. In order to help our customers in gambling responsibly,
                    we ensure that all our staff receive responsible gambling awareness training,
                    while we also provide the following information and features on our site.
                </p>

                <ul>
                    <li>Customer-driven loss limits;</li>
                    <li>Self-exclusion option by contacting Customer Service;</li>
                    <li>Links to SICAD, GamCare, Gambling Therapy and other organisations;</li>
                    <li>Self protection and awareness information;</li>
                    <li>
                        Information and tools to protect player’s account and prevent underage gaming.
                    </li>
                </ul>

                <h2>Temporary Account Closure/ Self-exclusion</h2>

                <p>
                    You may at Your discretion choose to restrict your access to your account
                    and/or exclude Yourself from playing any Games on the website, temporarily
                    or permanently. In order to restrict Your access to the Games or Self-exclude
                    You must visit the relevant section at your Account (Profile &gt; Player Protection)
                    or email Customer Support. Account blocking and Self-Exclusion requests take
                    effect immediately. To revoke a restriction of your account, contact Customer
                    Support. For your protection, it is possible that revocation of such restrictions
                    will take effect seven days after the receipt of your request, provided that the
                    time period that You have chosen has elapsed.
                </p>

                <h2>Maintaining control</h2>

                <p>
                    Whilst the majority of our customers gamble within their means for some it can
                    be more difficult. In order to maintain control of your gambling habits, we would
                    like you to bear in mind the following points:
                </p>

                <ul>
                    <li>
                        Gambling should be done in moderation and undertaken as a form of
                        entertainment and not as a way of making a living;
                    </li>
                    <li>Avoid chasing losses;</li>
                    <li>
                        Keep track of the time and monitor the amount of money you spend;
                    </li>
                    <li>
                        If you need help, use the loss limits functionality to help you control
                        the amount you can spend. These can be accessed from within the
                        "Settings" panel, from the "Profile" menu, under "Account" or you can
                        contact our Customer Support for help.
                    </li>
                    <li>
                        Should you need a break from gambling, Self-Exclusion can be set by
                        contacting our Customer Support;
                    </li>
                    <li>
                        If you need to talk to someone about any concerns you may have with
                        your gambling, please contact one of the organisations detailed below.
                    </li>
                </ul>

                <p>
                    In case you would like to monitor your account activity regarding any
                    transactions (deposit/ withdrawals/ Sportsbook bets, Casino bets) please
                    visit the relevant section at your account (History &gt; Transactions).
                    In the case that you notice that any of the transactions made at your account
                    was not initiated by You, then you should immediately notify Customer Support
                    through email and change your password. As part of the registration process,
                    You will have to choose Your username and password for logging into the website.
                    It is Your sole and exclusive responsibility to ensure that Your login details
                    are kept securely. You must not disclose or share Your login details with anyone.
                    website is not responsible for any abuse or misuse of Your Account by third
                    parties due to Your disclosure, whether intentional or accidental, whether active
                    or passive, of Your login details to any third party.
                </p>

                <h2>You think you have a problem?</h2>

                <p>
                    If you are concerned that gambling has had a negative impact on your or someone
                    else's life, then the following questions may help you find out more about your
                    gambling behaviour and whether it is problematic or not.
                </p>

                <ol className="responsible-gaming-questions">
                    <li>Have you ever neglected your studies or work due to gambling?</li>
                    <li>Do you gamble to pass time or out of boredom?</li>
                    <li>Do you play alone and for long periods of time?</li>
                    <li>Have others ever criticised your gambling?</li>
                    <li>
                        Have you ever lost interest in family, friends or hobbies due to gambling?
                    </li>
                    <li>
                        Has it ever happened to you to lie, borrow or even steal money to cover
                        gambling losses?
                    </li>
                    <li>
                        Has it ever happened to you to lie, borrow or even steal money for gambling?
                    </li>
                    <li>
                        Are you reluctant to spend money allocated for gambling on other goals?
                    </li>
                    <li>Do you gamble until you lose all your money?</li>
                    <li>
                        After losing, do you feel the need to play as soon as possible to cover losses?
                    </li>
                    <li>
                        Are there times that gambling follows after arguments, frustrations or
                        disappointments?
                    </li>
                    <li>Does gambling cause you depression or suicidal thoughts?</li>
                </ol>

                <p>
                    The more questions that you answer 'yes' to, the more likely it is that you
                    are having gambling issues. To speak with someone who can give you professional
                    advice and support, please contact one of the organisations detailed below:
                </p>

                <div className="responsible-gaming-links">
                    <a
                        href="https://www.gamcare.org.uk"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.gamcare.org.uk
                    </a>

                    <a
                        href="https://www.gamblingtherapy.org"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.gamblingtherapy.org
                    </a>

                    <a
                        href="https://www.gamblersanonymous.org.uk"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        www.gamblersanonymous.org.uk
                    </a>
                </div>

                <h2>Underage gambling</h2>

                <p>
                    It is illegal for anyone under the age of 18 to open an account or to gamble
                    on website. It takes very serious measures in this direction. We carry out age
                    verification checks on all customers who use payment methods which are available
                    to under 18's. Αdditionally, we randomly perform age verification checks on
                    customers using other payment methods.
                </p>

                <p className="responsible-gaming-warning">
                    PLEASE NOTE THAT ANYONE UNDER THE AGE OF 18 FOUND TO BE USING THIS SITE WILL
                    HAVE ANY WINNINGS FORFEITED AND MAY ALSO BE REPORTED TO THE POLICE.
                </p>

            </div>

              <section className="footer app-footer">
                
              
                <div className="footer-top">
                    <div className="footer-links">
                        <nav className="navbar navbar-expand-sm">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link" href="/terms-and-conditions" target="_blank">
                                        Terms and Conditions
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/responsible-gaming" target="_blank">
                                        Responsible Gaming
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="support-detail">
                        <h2>24X7 Support</h2>
                    </div>
                    <div className="social-icons-box"></div>
                </div>

                {/* 2. MIDDLE ROW: SSL Badge + Icons */}
                <div className="footer-bottom">
                    <div className="secure-logo">
                        <div>
                            <img src="https://wver.sprintstaticdata.com/v3/static/front/img/ssl.png" alt="SSL Secure" />
                        </div>
                        <div className="ml-2">
                            <b>100% SAFE</b>
                            <div>Protected connection and encrypted data.</div>
                        </div>
                    </div>
                    <div className="d-inline-block">
                        <button className="btn p-0">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/18plus.png" alt="18+" />
                        </button>
                        <a href="https://www.gamcare.org.uk/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gamecare.png" alt="Gamecare" />
                        </a>
                        <a href="https://www.gamblingtherapy.org/" target="_blank">
                            <img src="https://versionobj.ecoassetsservice.com/v105/static/front/img/gt.png" alt="GT" />
                        </a>
                    </div>
                </div>

                {/* 3. BOTTOM ROW: Copyright Text */}
                <div className="footer-text">
                    <p className="text-centerx">
                        © Copyright {new Date().getFullYear()}. All Rights Reserved. Powered by Black247.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ResponsibleGaming;